/**
 * portLabel(port, fallback = '-')
 *
 * Single source of truth for rendering voyage from/to fields as a string.
 * Voyage from/to is stored as `{ name: string, position: object | null }`,
 * but DRAFTs intentionally write `{ name: '', position: null }`, and legacy
 * voyages may carry bare strings. Rendering the raw object crashes React
 * with error #31. This helper is the only safe way to derive a label.
 *
 * @param {unknown} port - voyage.from, voyage.to, or any legacy shape
 * @param {string} fallback - text to return when no name can be resolved
 * @returns {string}
 */
export const portLabel = (port, fallback = '-') => {
  if (port == null) return fallback;
  if (typeof port === 'string') return port.trim() || fallback;
  if (typeof port === 'object' && typeof port.name === 'string') {
    return port.name.trim() || fallback;
  }
  return fallback;
};

export default portLabel;
